<ui-table [responsive]="true" [rows]="employeesWithStatusChip()">
  <div name="email" uiTableColumn>
    <ng-template uiTableHeader>
      Mitarbeiter
    </ng-template>
    <ng-template let-employee="item" uiTableCell>
      {{ employee.email }}
    </ng-template>
  </div>

  <div name="status" uiTableColumn>
    <ng-template uiTableHeader>
      Status
    </ng-template>
    <ng-template let-employee="item" uiTableCell>
      <span class="status-chip" [ngClass]="employee.statusChip.className">
	    {{ employee.statusChip.label }}
	  </span>
    </ng-template>
  </div>

  <div justifyContent="end" name="actions" uiTableColumn>
    <ng-template uiTableHeader>
      Aktionen
    </ng-template>
    <ng-template let-employee="item" uiTableCell>
      @if (employee.status !== 'active') {
        <button name="invite"
                matTooltip="Mitarbeiter erneut einladen"
                mat-icon-button
                type="button"
                (click)="onRenewInvitation(employee)"
        >
          <ui-icon class="action-icon" faName="envelope" faStyle="light"></ui-icon>
        </button>
      } @else {
        <span matTooltip="Mitarbeiter ist aktiv">
        <button name="invited"
                mat-icon-button
                type="button"
                disabled="disabled"
        >
          <ui-icon class="action-icon" faName="envelope-circle-check" faStyle="light"></ui-icon>
        </button>
        </span>
      }
      <button name="edit"
              matTooltip="Mitarbeiter bearbeiten"
              mat-icon-button
              type="button"
              (click)="onEdit(employee)"
      >
        <ui-icon class="action-icon" faName="pen-to-square" faStyle="light"></ui-icon>
      </button>
      <button name="delete"
              matTooltip="Mitarbeiter löschen"
              mat-icon-button
              type="button"
              (click)="onDelete(employee)"
      >
        <ui-icon class="action-icon" faName="trash" faStyle="light"></ui-icon>
      </button>
    </ng-template>
  </div>
</ui-table>
